import { useState, useEffect, useRef } from 'react';

export default function TargetAudience() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const audiences = [
    { icon: 'ri-code-box-line', title: 'Doanh nghiệp công nghệ', desc: 'Cần quản trị kỹ năng technical chuyên sâu', gradient: 'from-blue-50 to-cyan-50', border: 'border-[#06b6d4]/20', iconColor: '#2a4b7c' },
    { icon: 'ri-rocket-line', title: 'Doanh nghiệp chuyển đổi số', desc: 'Đang digitize quy trình HR và quản lý nhân sự', gradient: 'from-indigo-50 to-blue-50', border: 'border-[#2a5bd7]/20', iconColor: '#2a5bd7' },
    { icon: 'ri-building-line', title: 'Tổ chức chuẩn hóa năng lực', desc: 'Muốn xây dựng khung năng lực thống nhất', gradient: 'from-cyan-50 to-green-50', border: 'border-[#06b6d4]/20', iconColor: '#06b6d4' },
    { icon: 'ri-bar-chart-grouped-line', title: 'Công ty cần quản trị kỹ năng', desc: 'Ra quyết định nhân sự dựa trên dữ liệu', gradient: 'from-green-50 to-emerald-50', border: 'border-[#2ecc71]/20', iconColor: '#2ecc71' }
  ];

  return (
    <section ref={sectionRef} className="py-20">
      <div className="container mx-auto px-6">
        <div className={`max-w-4xl mx-auto text-center mb-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2a4b7c] mb-6">
            Stackway Skill Hub phù hợp với ai?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {audiences.map((audience, index) => (
            <div 
              key={index}
              className={`text-center p-6 bg-gradient-to-br ${audience.gradient} rounded-xl border ${audience.border} hover:shadow-lg hover:-translate-y-2 transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <i className={`${audience.icon} text-4xl mb-4`} style={{ color: audience.iconColor }}></i>
              <h3 className="font-bold text-[#2a4b7c] mb-2">{audience.title}</h3>
              <p className="text-sm text-slate-600">{audience.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
